export default __webpack_public_path__ + "assets/futurized.329bcb05.png";